const baseVariantShared = {
  alignItems: 'center',
  textAlign: 'center'
};

const base = {
  default: { ...baseVariantShared },
  masonry: { ...baseVariantShared },
  offset: { ...baseVariantShared },
  cards: { ...baseVariantShared }
};

const co = {
  default: {
    alignItems: 'flex-start',
    textAlign: 'left'
  },
  masonry: {
    alignItems: 'flex-start',
    textAlign: 'left'
  },
  offset: {
    alignItems: 'flex-start',
    textAlign: 'left'
  },
  cards: {
    alignItems: 'flex-start',
    textAlign: 'left'
  },
};

const titleSection = {
  products: {
    chart: base,
    chartblog: base,
    co,
    edu: base,
    scale: base,
    spark: base
  }
};

export default titleSection;
